var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('div',[_c('fm-title',{attrs:{"title-text":"职务信息"}}),(_vm.data && _vm.data.userId)?_c('div',{staticStyle:{"padding":"0 20px"}},[_c('UserOrgRoleForm',{attrs:{"user-id":_vm.data.userId},on:{"reload":_vm.loadData}})],1):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }